import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button
} from 'semantic-ui-react'

const ANES_PACU_Tab = (props: any) => {

    const isMounted = React.useRef(true);
    const intl = useIntl();

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        className="pacu-record-tabs"
        id="ANES_PACU_Tab-div-0"
        style={{ height: "80px" }}>
        <div
          id="ANES_PACU_Tab-div-1"
          style={{ display: "flex" ,padding : "10px", }}>

          <Button
            id="ANES_PACU_Tab-Button-6"
            name="Anesthesia"
            onClick={props.onChangeContainerName}
            style={{ color: props.tab === "Anesthesia" ? "blue" : "grey" }}>
            {props.languageUX === "en" ? "Anesthesia" : "การดมยาสลบ"}
          </Button>
          <Button
            id="ANES_PACU_Tab-Button-7"
            name="Intraoperative"
            onClick={props.onChangeContainerName}
            style={{ color: props.tab === "Intraoperative" ? "blue" : "grey" }}>
            {props.languageUX === "en" ? "Intraoperative intake/output" : "การรับ/ส่งออกระหว่างการผ่าตัด"}
          </Button>
          <Button
            id="ANES_PACU_Tab-Button-8"
            name="PostAnesthetic"
            onClick={props.onChangeContainerName}
            style={{ color: props.tab === "PostAnesthetic" ? "blue" : "grey" }}>
            {props.languageUX === "en" ? "Post anesthetic recovery score" : "คะแนนการฟื้นตัวหลังการดมยาสลบ"}
          </Button>
          <Button
            name="AnesVitalSign"
            onClick={props.onChangeContainerName}
            style={{ color: props.tab === "AnesVitalSign" ? "blue" : "grey" }}>
            {props.languageUX === "en" ? "Vital Sign" : "Vital Sign"}
          </Button>
          <Button
            id="ANES_PACU_Tab-Button-9"
            name="Monitor"
            onClick={props.onChangeContainerName}
            style={{ color: props.tab === "Monitor" ? "blue" : "grey" }}>
            {props.languageUX === "en" ? "Monitor & Nursing care" : "การติดตามและการดูแลพยาบาล"}
          </Button>
          <Button
            id="ANES_PACU_Tab-Button-10"
            name="Medication"
            onClick={props.onChangeContainerName}
            style={{ color: props.tab === "Medication" ? "blue" : "grey", display: "none" }}>
            {props.languageUX === "en" ? "Medication" : "ยา"}
          </Button>
          <Button
            id="ANES_PACU_Tab-Button-11"
            name="Problems"
            onClick={props.onChangeContainerName}
            style={{ color: props.tab === "Problems" ? "blue" : "grey" }}>
            {props.languageUX === "en" ? "Problems/Remarks" : "ปัญหา/ข้อสังเกต"}
          </Button>
          <Button
            id="ANES_PACU_Tab-Button-15"
            name="Referral"
            onClick={props.onChangeContainerName}
            style={{ color: props.tab === "Referral" ? "blue" : "grey" }}>
            {props.languageUX === "en" ? "Referral data for transfer" : "ข้อมูลอ้างอิงสำหรับการโอน"}
          </Button>
          <Button
            name="Fluid"
            onClick={props.onChangeContainerName}
            style={{ color: props.tab === "Fluid" ? "blue" : "grey" }}>
            {props.languageUX === "en" ? "Medication / IV Fluid" : "Medication / IV Fluid"}
          </Button>
        </div>
        <div
          id="ANES_PACU_Tab-div-13"
          style={{width:"100%" , marginLeft:"10px"}}>

          <hr
            id="ANES_PACU_Tab-hr-14">
          </hr>
        </div>
      </div>
    )
}


export default ANES_PACU_Tab

export const screenPropsDefault = {}

/* Date Time : Wed Aug 20 2025 10:27:57 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "className": {
          "type": "value",
          "value": "pacu-record-tabs"
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"80px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\" ,padding : \"10px\", }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "การดมยาสลบ",
          "valueEN": "Anesthesia"
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-Button-6"
        },
        "name": {
          "type": "value",
          "value": "Anesthesia"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeContainerName"
        },
        "style": {
          "type": "code",
          "value": "{ color: props.tab === \"Anesthesia\" ? \"blue\" : \"grey\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "การรับ/ส่งออกระหว่างการผ่าตัด",
          "valueEN": "Intraoperative intake/output"
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-Button-7"
        },
        "name": {
          "type": "value",
          "value": "Intraoperative"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeContainerName"
        },
        "style": {
          "type": "code",
          "value": "{ color: props.tab === \"Intraoperative\" ? \"blue\" : \"grey\" }"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "คะแนนการฟื้นตัวหลังการดมยาสลบ",
          "valueEN": "Post anesthetic recovery score"
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-Button-8"
        },
        "name": {
          "type": "value",
          "value": "PostAnesthetic"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeContainerName"
        },
        "style": {
          "type": "code",
          "value": "{ color: props.tab === \"PostAnesthetic\" ? \"blue\" : \"grey\" }"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "การติดตามและการดูแลพยาบาล",
          "valueEN": "Monitor & Nursing care"
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-Button-9"
        },
        "name": {
          "type": "value",
          "value": "Monitor"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeContainerName"
        },
        "style": {
          "type": "code",
          "value": "{ color: props.tab === \"Monitor\" ? \"blue\" : \"grey\" }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ยา",
          "valueEN": "Medication"
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-Button-10"
        },
        "name": {
          "type": "value",
          "value": "Medication"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeContainerName"
        },
        "style": {
          "type": "code",
          "value": "{ color: props.tab === \"Medication\" ? \"blue\" : \"grey\", display: \"none\" }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ปัญหา/ข้อสังเกต",
          "valueEN": "Problems/Remarks"
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-Button-11"
        },
        "name": {
          "type": "value",
          "value": "Problems"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeContainerName"
        },
        "style": {
          "type": "code",
          "value": "{ color: props.tab === \"Problems\" ? \"blue\" : \"grey\" }"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-div-13"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\" , marginLeft:\"10px\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "hr",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-hr-14"
        }
      },
      "seq": 14,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อมูลอ้างอิงสำหรับการโอน",
          "valueEN": "Referral data for transfer"
        },
        "id": {
          "type": "value",
          "value": "ANES_PACU_Tab-Button-15"
        },
        "name": {
          "type": "value",
          "value": "Referral"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeContainerName"
        },
        "style": {
          "type": "code",
          "value": "{ color: props.tab === \"Referral\" ? \"blue\" : \"grey\" }"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Vital Sign",
          "valueEN": "Vital Sign"
        },
        "name": {
          "type": "value",
          "value": "AnesVitalSign"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeContainerName"
        },
        "style": {
          "type": "code",
          "value": "{ color: props.tab === \"AnesVitalSign\" ? \"blue\" : \"grey\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Medication / IV Fluid",
          "valueEN": "Medication / IV Fluid"
        },
        "name": {
          "type": "value",
          "value": "Fluid"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeContainerName"
        },
        "style": {
          "type": "code",
          "value": "{ color: props.tab === \"Fluid\" ? \"blue\" : \"grey\" }"
        }
      },
      "seq": 17,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": true,
  "memo": false,
  "name": "ANES_PACU_Tab",
  "project": "IsHealth_by_Front-end",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
